var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-post-list"},_vm._l((_vm.$store.state.posts),function(post){return _c('div',[_c('img',{attrs:{"src":post.author.iconUrl}}),_vm._v(" "),_c('div',{staticClass:"inline-title"},[_c('a',{attrs:{"href":("/projects/" + (post.project.id) + "/discussions/" + (post.postNumber))}},[_vm._v("\n        "+_vm._s(post.title)+"\n      ")])])])}))}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./assets/js/components/PostList.vue?vue&type=template&id=091124ad&
// module id = 227
// module chunks = 0